import { render, staticRenderFns } from "./RolesExport.vue?vue&type=template&id=dde3e0e8"
import script from "./RolesExport.vue?vue&type=script&lang=js"
export * from "./RolesExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports